import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home'
import Layout from './layout'
import Service from '../src/views/service'
import Purpose from '../src/views/service/purpose'
import Spirit from '../src/views/service/spirit'
import Mission from '../src/views/service/mission'
import Strength from '../src/views/service/strength'
import Characteristic from '../src/views/service/characteristic'
import Seven from '../src/views/theSeven'
import Team from '../src/views/team'
import TriTone from '../src/views/triTone'
import GroupStrength from '../src/views/groupStrength'
import Group from '../src/views/groupStrength/group'
import About from '../src/views/groupStrength/about'
import EntryAbout from '../src/views/about'
import News from '../src/views/groupStrength/news'
import Articles from '../src/views/articles'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home,
        },
        {
          path: '/service',
          name: 'service',
          component: Service,
          redirect: '/service/purpose',
          children: [
            {
              path: '/service/purpose',
              name: 'purpose',
              component: Purpose
            },
            {
              path: '/service/spirit',
              name: 'spirit',
              component: Spirit
            },
            {
              path: '/service/mission',
              name: 'mission',
              component: Mission
            },
            {
              path: '/service/strength',
              name: 'strength',
              component: Strength
            },
            {
              path: '/service/characteristic',
              name: 'characteristic',
              component: Characteristic
            }
          ]
        },
        {
          path: '/theSeven',
          name: 'theSeven',
          component: Seven
        },
        {
          path: '/team',
          name: 'team',
          component: Team
        },
        {
          path: '/triTone',
          name: 'triTone',
          component: TriTone
        },
        {
          path: '/groupStrength',
          name: 'groupStrength',
          component: GroupStrength,
          redirect: '/groupStrength/group',
          children: [
            {
              path: '/groupStrength/group',
              name: 'group',
              component: Group
            },
            {
              path: '/groupStrength/about',
              name: 'about',
              component: About
            },
            {
              path: '/groupStrength/news',
              name: 'news',
              component: News
            },
          ]
        },
      ]
    },
    {
      path: '/entryAbout',
      name: 'entryAbout',
      component: EntryAbout
    },
    {
      path: '/articles',
      name: 'articles',
      component: Articles
    },
  ]
})
